/* eslint-disable complexity */
import { TextCollectionAttachment } from '@scale/shared/types/params/textcollection';
import React, { useState } from 'react';
import { makeStyles } from 'react-scale/components/design-system/styles';
// import { useChatbotContext } from 'react-scale/dashboard.scale.com/contexts/ChatbotRankingContext';

import { TextCollectionAnnotationsOrCallback } from '@scale/shared/types/textCollection';
import { Breadcrumb } from 'react-scale/components/scalers/tasks/textcollection/breadcrumbs';
import { TextField, Button } from '@scale/scaleui';
import PairwiseEvaluation from 'react-scale/components/scalers/tasks/textcollection/PairwiseEvaluation';
import { CircularProgress, Paper } from 'react-scale/components/design-system';

interface Props {
  attachment: TextCollectionAttachment;
  projectId?: string;
  assignmentId?: string;
  setAnnotations?: (
    annotations: TextCollectionAnnotationsOrCallback,
    breadcrumbs?: Breadcrumb[],
  ) => void;
}

const RLHFPairwiseEvaluation: React.FC<Props> = (props: Props) => {
  const classes = useStyles();

  // const chatbotContext = useChatbotContext();
  const [prompt, setPrompt] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState<boolean>(false);
  const [leftText, setLeftText] = useState<string>('');
  const [rightText, setRightText] = useState<string>('');
  const handleSubmit = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setLoading(true);
      // const response: GetCompletionsResponse = await API.selfserve.fetchResponsesFromChatEndpoint({
      //   endpointUrl: rlhfParams!.chatApiEndpoint,
      //   getCompletionsRequest: {
      //     numCompletions: rlhfParams!.numberOfCompletions,
      //     nextPrompt: prompt,
      //     history: { interactions: [] },
      //     additionalParams: rlhfParams!.chatApiAdditionalParams
      //       ? rlhfParams!.chatApiAdditionalParams
      //       : undefined,
      //     chatApiMultiEndpoints: [endPointsToBeFetched],
      //   },
      //   taskCustomer,
      // });

      // wait one second to simulate loading
      await new Promise(resolve => setTimeout(resolve, 1000));

      // TODO: set annotations too
      setLeftText(
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      );
      setRightText(
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      );
      setShowResult(true);
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    // TODO: remove annotations
    setLeftText('');
    setRightText('');
    setShowResult(false);
  };

  if (loading) {
    return (
      <Paper className={classes.attachment}>
        <div className={classes.centered}>
          <CircularProgress />
        </div>
      </Paper>
    );
  }

  return (
    <Paper className={classes.attachment}>
      {!showResult ? (
        <div>
          <h1 className="text-l font-medium text-neutral-700">{props.attachment.content}</h1>
          <TextField
            id="editPrompt"
            type="text"
            value={prompt}
            onChange={e => setPrompt(e.target.value)}
            onKeyDown={handleSubmit}
            description="Press Enter to submit"
          />
        </div>
      ) : (
        <>
          <PairwiseEvaluation content={prompt} left={leftText} right={rightText} />
          <Button color="secondary" onClick={handleCancel}>
            Try another prompt
          </Button>
        </>
      )}
    </Paper>
  );
};

const useStyles = makeStyles({
  attachment: {
    margin: 24,
    padding: 32,
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default RLHFPairwiseEvaluation;
